module.exports = __webpack_public_path__ + "media/images/client_certificate_selection/certificates_in_ie_default-480c8763dbe816d6ee359fbabbbc7c5c.jpg";